export default "__VITE_ASSET__Cot9Corj__"